import './index.css'
import {
    accountApiUrl,
    baseApiUrl
}from '../../config/index'

function showBg(){
    let doms = document.querySelectorAll(".section-bg:not(.fade-in)")
    if (!doms.length) {
        return
    }
    Array.prototype.map.call(doms, (item) => {
        let top = item.getBoundingClientRect().top
        if (top < window.innerHeight) {
            item.className = item.className + " fade-in"
        }
    })
}

function getUrlParams(url) {
    var reg = /[\?&]([^=&]+)[=]{0,1}([^&#]*)/g,
        url = url || window.location.href,
        params = {},
        execR = reg.exec(url);
    while (execR) {
        params[execR[1]] = decodeURIComponent(execR[2]);
        execR = reg.exec(url);
    }
  
    for (var key in params) {
        if (!params[key]) {
            delete params[key];
        }
    }
    return params;
  }

function init(){
    let timer
    let $ = (str) => document.querySelector(str)
    let params = getUrlParams(location.href)
    params.from = 'cloudwelcome'

    //统计
    // _dw.setAppKey('da375dedfadf11fb') //【必填】调用此方法，传入你产品的唯一标识
    //   .setDebug(false) //在调试时开启为true,线上环境请务必开启为false
    //   .setChannel("wps_oversea_cloud") //设置渠道
    //   .setVersion('web_2.0') //设置版本
    // 统计改为firebase
    window._dw = {};
    _dw.onEvent = function(eventName, params) {
        if (!window.fireEvent) {
            window.firebase && firebase.initializeApp({
                apiKey: "AIzaSyAn-G0h9BgJFwWNo7sF111m1QauxaofdCM",
                authDomain: "ovscloud-analysis.firebaseapp.com",
                databaseURL: "https://ovscloud-analysis.firebaseio.com",
                projectId: "ovscloud-analysis",
                storageBucket: "ovscloud-analysis.appspot.com",
                messagingSenderId: "259837498140",
                appId: "1:259837498140:web:8eba1e93978dfc224120d9",
                measurementId: "G-RN1HGKZN75"
            })
            window.fireEvent = window.firebase && firebase.analytics();
        }
        if (params) {
            for (var i in params) {
                var val = params[i]
                params[i] = typeof val === "object" ? JSON.stringify(val) : val
            }
            params["from"] = "mdrive"
        }
        window.fireEvent && fireEvent.logEvent(eventName, params);
    }

    _dw.onEvent("mdrive_pageview_welcome")

    setTimeout(() => {
        $('.wordbg') ? $('.wordbg').classList.add('fade-in') : ''
    }, 100);
    setTimeout(() => {
        $('.groupbg') ? $('.groupbg').classList.add('fade-in') : ''
    }, 500);

    window.addEventListener("scroll", (e) => {
        if (timer) return;
        timer = setTimeout(() => {
            timer = null
        }, 300);
        showBg()
    })

    Array.prototype.map.call(document.querySelectorAll('.loginBtn'),(item) => {
        item.addEventListener('click',() => {
            params.cb = params.cb || encodeURIComponent(baseApiUrl)
            let str = ''
            for (var k in params){
                str += `${k}=${params[k]}&`
            }
            str = str.slice(0,-1)
            setTimeout(() => {
                location.href = accountApiUrl + `?${str}`
            }, 300);
        })
    })
    Array.prototype.map.call(document.querySelectorAll('.pla-item'),(item) => {
        item.addEventListener('click',() => {
            setTimeout(() => {
                location.href = item.dataset.url
            }, 300);
        })
    })
}
init()
showBg()


// WEBPACK FOOTER //
// ./src/apps/welcome/index.js